/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_Island_NationsInputs */

const bn_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দ্বীপ দেশগুলো`)
};

const de_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inselstaaten`)
};

const el_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νησιωτικά έθνη`)
};

const en_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Island nations`)
};

const es_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naciones insulares`)
};

const fr_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nations insulaires`)
};

const hi_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द्वीप राष्ट्र`)
};

const hu_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szigeti nemzetek`)
};

const id_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negara kepulauan`)
};

const it_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nazioni insulari`)
};

const ja_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`島国`)
};

const ko_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`섬나라`)
};

const nl_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eilandstaten`)
};

const pl_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narody wyspiarskie`)
};

const pt_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nações insulares`)
};

const ru_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Островные государства`)
};

const sv_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önationer`)
};

const tr_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada ülkeleri`)
};

const uk_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Острівні держави`)
};

const vi_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quốc đảo`)
};

const zh_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`岛国`)
};

const zh_hant_region_island_nations = /** @type {(inputs: Region_Island_NationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`島國`)
};

/**
* | output |
* | --- |
* | "Island nations" |
*
* @param {Region_Island_NationsInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_island_nations = /** @type {((inputs?: Region_Island_NationsInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_Island_NationsInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_island_nations(inputs)
	if (locale === "de") return de_region_island_nations(inputs)
	if (locale === "el") return el_region_island_nations(inputs)
	if (locale === "en") return en_region_island_nations(inputs)
	if (locale === "es") return es_region_island_nations(inputs)
	if (locale === "fr") return fr_region_island_nations(inputs)
	if (locale === "hi") return hi_region_island_nations(inputs)
	if (locale === "hu") return hu_region_island_nations(inputs)
	if (locale === "id") return id_region_island_nations(inputs)
	if (locale === "it") return it_region_island_nations(inputs)
	if (locale === "ja") return ja_region_island_nations(inputs)
	if (locale === "ko") return ko_region_island_nations(inputs)
	if (locale === "nl") return nl_region_island_nations(inputs)
	if (locale === "pl") return pl_region_island_nations(inputs)
	if (locale === "pt") return pt_region_island_nations(inputs)
	if (locale === "ru") return ru_region_island_nations(inputs)
	if (locale === "sv") return sv_region_island_nations(inputs)
	if (locale === "tr") return tr_region_island_nations(inputs)
	if (locale === "uk") return uk_region_island_nations(inputs)
	if (locale === "vi") return vi_region_island_nations(inputs)
	if (locale === "zh") return zh_region_island_nations(inputs)
	return zh_hant_region_island_nations(inputs)
});